export const BoostActive = {
  parts: ['Container', 'Top', 'TopMessage'],
  baseStyle: {
    Container: {
      bg: 'brand.lightgreen2',
      p: '0',
      borderBottom: '1px solid',
      borderColor: 'brand.lightgrey',
    },
    Top: {
      bg: 'brand.green',
      p: '3',
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
    },
    TopMessage: {
      textAlign: 'center',
      p: '0',
      color: 'brand.white',
      textTransform: 'uppercase',
      fontWeight: '600',
      fontSize: 'xs',
      letterSpacing: '1px',
    },
    Bottom: {
      pl: '64px',
      pr: '64px',
      pt: '5',
      pb: '5',
    },
  },
};
